export default {"src":"/_next/static/media/share.305fa137.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};